import { getAppDetailsByAppKeys, HitsType, resolveHits } from '@atlassian/amkt-addon-discovery';
import { hooks } from '@atlassian/mpac-utils';
import { getAppRecommendations } from '../../services/AppRecommendations';
import newAndNoteworthyApps from './newAndNoteworthyApps';

// types

const getRecommendedAppKeys = (cloudId, hostProduct) => {
  return getAppRecommendations(cloudId, hostProduct).then(_ref => {
    let {
      appRecommendations
    } = _ref;
    return appRecommendations.map(appRecommendation => appRecommendation.appKey);
  });
};
async function getRecommendedAppsDetails(algoliaClient, environment, cloudId, hostProduct) {
  let recommendedAppKeys = await getRecommendedAppKeys(cloudId, hostProduct);
  let hitsType = HitsType.recommendedApps;
  if (!recommendedAppKeys.length) {
    if (hostProduct === 'jira') {
      recommendedAppKeys = newAndNoteworthyApps.jira.sort(() => 0.5 - Math.random()).slice(0, 3);
    } else if (hostProduct === 'confluence') {
      recommendedAppKeys = newAndNoteworthyApps.confluence.sort(() => 0.5 - Math.random()).slice(0, 3);
    }
    hitsType = HitsType.newAndNoteworthyApps;
  }
  return getAppDetailsByAppKeys(algoliaClient, environment, recommendedAppKeys).then(_ref2 => {
    let {
      content = {}
    } = _ref2;
    return {
      hits: resolveHits((content.hits || []).sort((a, b) => recommendedAppKeys.indexOf(a.addonKey) > recommendedAppKeys.indexOf(b.addonKey) ? 1 : -1)),
      numberOfHits: content.nbHits || 0,
      hitsType
    };
  });
}
export const useRecommendations = (algoliaClient, environment, cloudId, hostProduct) => {
  const fetchRecommendedAppsPromise = () => getRecommendedAppsDetails(algoliaClient, environment, cloudId, hostProduct);
  const {
    result,
    error,
    pending
  } = hooks.usePromise(fetchRecommendedAppsPromise, [cloudId, hostProduct]);
  return {
    fetchRecommendedAppsPending: pending,
    fetchRecommendedAppsError: error,
    fetchRecommendedAppsResult: result
  };
};